import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { GetEntitiesDetailsClientResponse } from '../@types/GetEntitiesDetails'

export type AgentSessionTypes = [string, string, number, boolean] | null

type Store = {
  getEntitiesDetails: GetEntitiesDetailsClientResponse | null
  setGetEntitiesDetails: (
    getEntitiesDetails: GetEntitiesDetailsClientResponse,
  ) => void
}

export const useGetEntitiesDetailsStore = create<Store>()(
  devtools(
    (set) => ({
      getEntitiesDetails: null,
      setGetEntitiesDetails: (getEntitiesDetails) =>
        set({ getEntitiesDetails }),
    }),
    { name: 'GetEntitiesDetailsStore' },
  ),
)
